module.exports = __webpack_public_path__ + "media/images/integrated-payments-1-603229b2fb87c0e385f40b4f031eb240.svg";